export const loginUrl = "/portal-auth/authenticate";

export const refreshTokenUrl = "/portal-auth/refresh-token";

export const resetQrUrl = "/portal-auth/token-2fa";
